import type { Country } from '@seek/melways-sites';

const TOUR_ID_AU_PRODUCTION = '202224';
const TOUR_ID_AU_DEV = '202220';
const TOUR_ID_NZ_PRODUCTION = '208565';
const TOUR_ID_NZ_DEV = '208566';

const isProduction = () => !/\.staging|local$/.test(window.location.host);

const getTourId = (country: Country) => {
  switch (country) {
    case 'au':
      return isProduction() ? TOUR_ID_AU_PRODUCTION : TOUR_ID_AU_DEV;
    case 'nz':
      return isProduction() ? TOUR_ID_NZ_PRODUCTION : TOUR_ID_NZ_DEV;
  }
};

export const openTour = (country: Country) => {
  if (window.Intercom) {
    /* eslint-disable-next-line new-cap */
    window.Intercom('startTour', getTourId(country));
  }
};
